"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledDragEditContainer = exports.DragEditButton = void 0;
var _ykbStyledComponents = _interopRequireWildcard(require("../../ykb-styled-components"));
var _Button = _interopRequireDefault(require("../../Button"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var StyledDragEditContainer = exports.StyledDragEditContainer = _ykbStyledComponents.default.div.withConfig({
  componentId: "ykb-ui__sc-1ebimok-0"
})(["background:", ";position:absolute;left:0px;top:0px;width:100%;height:100%;display:flex;justify-content:space-between;"], function (props) {
  return props.theme.color.primary6;
});
var DragEditButton = exports.DragEditButton = (0, _ykbStyledComponents.default)(_Button.default).withConfig({
  componentId: "ykb-ui__sc-1ebimok-1"
})(["color:white;background-color:", ";border:none;border-radius:0px;height:100%;", " &:hover{background-color:", ";}"], function (props) {
  return props.theme.color.primary7;
}, function (props) {
  return props.$noMargin && (0, _ykbStyledComponents.css)(["margin:0px;"]);
}, function (props) {
  return props.theme.color.primary8;
});